import { Facet } from '../../search-spring/types/types'
import DesktopFilter from './DesktopFilter'

type Props = {
  filters: Facet[]
}

const FilterItems = ({ filters }: Props): JSX.Element => {
  const filteredFilter = CD_STATE.searchspring.filterIgnoreOptions.length
    ? filters.filter((filter) => !CD_STATE.searchspring.filterIgnoreOptions.includes(filter.field))
    : filters

  const ComponentHandler = (): JSX.Element => {
    if (filteredFilter.length) {
      return (
        <>
          <div className="flex flex-row justify-between flex-1 p-5 min-w-0 gap-8 3xl:justify-start 3xl:gap-20">
            {filteredFilter.map((filter: Facet, index: number) => (
              <div key={index}>
                <h2 className="font-bstSpyre uppercase text-sm">{filter.label}</h2>
                <div className="mt-XS">
                  <div className={`gap-x-5 ${filter.values.length > 8 ? 'columns-2 [&>.filter-desktop-item]:mb-[5px]' : 'grid grid-rows-1 gap-y-2XS'}`}>
                    {filter.values.map((value, subIndex: number) => (
                      <DesktopFilter key={subIndex} filterValue={value} filter={filter} />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )
    }

    return (
      <>
        <div className="font-calibre text-base p-5 flex flex-grow flex-shrink-0 min-w-0 gap-x-5">
          If you are not seeing any results, try removing some of your selected filters.
        </div>
      </>
    )
  }

  return <ComponentHandler />
}

export default FilterItems
